import React from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Highlights from "@/components/Highlights";
import WhyUs from "@/components/WhyUs";
import Spectrum from "@/components/Spectrum";
import VideoGallery from "@/components/VideoGallery";
import AccidentProcess from "@/components/AccidentProcess";
import Team from "@/components/Team";
import Gallery from "@/components/Gallery";
import InstagramReel from "@/components/InstagramReel";
import InstagramFeed from "@/components/InstagramFeed";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ChatbotWidget from "@/components/ChatbotWidget";
import Certification from "@/components/Certification";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#050505] text-white">
      <Navigation />
      <main>
        <Hero />
        <Team />
        <Highlights />
        <WhyUs />
        <Certification />
        <Spectrum />
        <VideoGallery />
        <AccidentProcess />
        <Gallery />
        <InstagramReel />
        <InstagramFeed />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <ChatbotWidget />
    </div>
  );
}
